/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Interview_Practice_Answered_CountInputs */

const en_interview_practice_answered_count = /** @type {(inputs: Interview_Practice_Answered_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} answered`)
};

const de_interview_practice_answered_count = /** @type {(inputs: Interview_Practice_Answered_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} beantwortet`)
};

const fr_interview_practice_answered_count = /** @type {(inputs: Interview_Practice_Answered_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} répondue`)
};

const es_interview_practice_answered_count = /** @type {(inputs: Interview_Practice_Answered_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} respondida`)
};

const it_interview_practice_answered_count = /** @type {(inputs: Interview_Practice_Answered_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} con risposta`)
};

const nl_interview_practice_answered_count = /** @type {(inputs: Interview_Practice_Answered_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} beantwoord`)
};

const pl_interview_practice_answered_count = /** @type {(inputs: Interview_Practice_Answered_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} odpowiedzi`)
};

const fi_interview_practice_answered_count = /** @type {(inputs: Interview_Practice_Answered_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} vastattu`)
};

const da_interview_practice_answered_count = /** @type {(inputs: Interview_Practice_Answered_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} besvaret`)
};

const sv_interview_practice_answered_count = /** @type {(inputs: Interview_Practice_Answered_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} besvarade`)
};

/**
* | output |
* | --- |
* | "{count} answered" |
*
* @param {Interview_Practice_Answered_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_answered_count = /** @type {((inputs: Interview_Practice_Answered_CountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Answered_CountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_answered_count(inputs)
	if (locale === "fr") return fr_interview_practice_answered_count(inputs)
	if (locale === "es") return es_interview_practice_answered_count(inputs)
	if (locale === "it") return it_interview_practice_answered_count(inputs)
	if (locale === "nl") return nl_interview_practice_answered_count(inputs)
	if (locale === "pl") return pl_interview_practice_answered_count(inputs)
	if (locale === "fi") return fi_interview_practice_answered_count(inputs)
	if (locale === "da") return da_interview_practice_answered_count(inputs)
	if (locale === "sv") return sv_interview_practice_answered_count(inputs)
	return en_interview_practice_answered_count(inputs)
});